import { Injectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  GetProducts,
  GetProduct,
  SearchResultV2,
  CheckContractedProductsResponse,
} from '../models/product-v2.model';
import { unformatCnpj } from '../utils/cnpj.util';

import { ApiService } from './api.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProductV2Service {
  private readonly API_URL = '/productsv2';
  private apiService = inject(ApiService);
  private authService = inject(AuthService);


  getProducts(): Observable<GetProducts> {
    return this.apiService.get<GetProducts>(this.API_URL);
  }

  getProductByUuid(uuid: string): Observable<GetProduct> {
    return this.apiService.get<GetProduct>(`${this.API_URL}/${uuid}`);
  }

  getProductsByCategory(categoryUuid: string): Observable<GetProducts> {
    const url = `${this.API_URL}/category/${categoryUuid}`;
    const options = this.catalogQueryOptions();
    return this.apiService.get<GetProducts>(url, options);
  }

  checkContractedProducts(
    document: string
  ): Observable<CheckContractedProductsResponse> {
    const cleanDocument = unformatCnpj(document);
    return this.apiService.get<CheckContractedProductsResponse>(
      `${this.API_URL}/check-contracted-products/${encodeURIComponent(cleanDocument)}`
    );
  }

  private catalogQueryOptions(): { params: HttpParams } | undefined {
    if (!this.authService.isFixaSession()) {
      return undefined;
    }
    return { params: new HttpParams().set('fixaLoggedIn', 'true') };
  }

  searchProducts(searchValue: string): Observable<SearchResultV2[]> {
    const url = `/products/search/v2?value=${encodeURIComponent(searchValue)}`;
    return this.apiService.get<SearchResultV2[]>(url);
  }
}
